import {useCallback, useState} from 'react';

import {useGetRefundStateQuery} from '../queries/useGetRefundStatesQuery';

export function useGetStates() {
	const [open, setOpen] = useState(false);
	const [isErrorState, setIsErrorState] = useState(false);
	const {data: options, refetch, isLoading} = useGetRefundStateQuery();

	const loadingList = open && isLoading;

	const handleOpen = useCallback(async () => {
		setOpen(true);
		if (!options) {
			const response = await refetch();
			if (response.isError) {
				setIsErrorState(true);
			}
		}
	}, [options]);

	const handleClose = useCallback(async () => {
		setOpen(false);
	}, []);

	const handleRefresh = useCallback(async () => {
		setIsErrorState(false);
	}, []);

	return {
		loadingList,
		options,
		open,
		handleOpen,
		handleClose,
		isError: isErrorState,
		handleRefresh,
	};
}
